export const GMAPS_API_KEY = 'AIzaSyCeM6OuOYuHL1rHahppuiQlWN0Z6nGCM78';
export const GMAPS_SECRET_SIGNATURE = '1jJKMnyZumq1SRTDBo564ymW0hc=';
